module.exports = __webpack_public_path__ + "img/ic_24_playlist_start.f8846833.svg";